import React from 'react'
import profile_image from "../../asserts/admin_img.png"
const Profile = () => {
  return (
    <div className='profile'>
      <div className='profile_container'>
        <div className="profile_img">
          <img src={profile_image} alt="" />
        </div>
        <div className="profile_content">
          <p className='profile_name'>Pratheesh</p>
          <p className='profile_role'>Super Admin</p>
          <p className='profile_email'>Admin@gmail.com</p>
        </div>
      </div>
    </div>
  )
}

export default Profile
